/*
 * @Author: YuanYuan
 * @Date: 2025-01-21 11:28:11
 * @LastEditTime: 2025-08-22 13:56:46
 * @Description: 域名组
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'addGroup',
    path: `${prefix}/domainGroup/add`,
    method: 'post',
    params: {
      groupName: '',
      remark: '',
      domains: ''
    },
    desc: '添加域名组'
  },
  {
    name: 'updateGroup',
    path: `${prefix}/domainGroup/update`,
    method: 'post',
    params: {
      groupName: '',
      id: '',
      domains: '',
      remark: ''
    },
    desc: '修改域名组'
  },
  {
    name: 'deleteGroup',
    path: `${prefix}/domainGroup/delete`,
    method: 'get',
    params: {
      id: ''
    },
    desc: '删除域名组'
  },
  {
    name: 'groupDetails',
    path: `${prefix}/domainGroup/get`,
    method: 'get',
    params: {
      id: ''
    },
    desc: '域名组详情'
  },
  {
    name: 'unGroupedDomains',
    path: `${prefix}/domainGroup/getUnGroupDomains`,
    method: 'get',
    params: {},
    desc: '获取未分组域名'
  },
  {
    name: 'downloadGroups',
    path: `${prefix}/domainGroup/download`,
    method: 'get',
    params: {},
    desc: '下载域名组'
  }
]
